<template>
    <span class="chat-message-text">
        <template v-for="(part, index) in parts">
            <a
                v-if="part.type === 'link'"
                :key="`link-${index}`"
                class="chat-message-text__link"
                :href="part.href"
                target="_blank"
                rel="noopener noreferrer"
            >{{ part.value }}</a>
            <span
                v-else
                :key="`text-${index}`"
            >{{ part.value }}</span>
        </template>
    </span>
</template>

<script>
    import { parseChatMessageLinks } from '@/utils/chatMessageLinks';

    export default {
        name: 'ChatMessageText',
        props: {
            text: {
                type: String,
                default: ''
            }
        },
        computed: {
            parts() {
                return parseChatMessageLinks(this.text);
            }
        }
    };
</script>

<style scoped>
.chat-message-text__link {
    color: inherit;
    text-decoration: underline;
    word-break: break-all;
}
</style>
